import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api, brl } from "@/lib/api";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const { refresh } = useAuth();
  const [state, setState] = useState({ kind: "checking" });
  useEffect(() => {
    let tries = 0;
    let stop = false;
    const poll = async () => {
      if (stop || !ref) return setState({ kind: "error" });
      try {
        const { data } = await api.get(`/billing/status/${ref}`);
        if (data.payment_status === "paid") { await refresh(); return setState({ kind: "paid", data }); }
        if (["expired", "rejected", "cancelled"].includes(data.payment_status)) return setState({ kind: "failed", data });
        tries += 1;
        if (tries >= 15) return setState({ kind: "pending", data });
        setTimeout(poll, 2000);
      } catch {
        setState({ kind: "error" });
      }
    };
    poll();
    return () => { stop = true; };
  }, [ref, refresh]);
  const view = {
    checking: [Loader2, "Confirmando pagamento…", "Aguarde alguns segundos.", "animate-spin text-primary"],
    paid: [CheckCircle2, "Pagamento aprovado!", `Plano ${state.data?.plan_id} (${state.data?.period}) liberado · ${brl(state.data?.amount)}`, "text-emerald-500"],
    pending: [Clock, "Pagamento pendente", "Assim que o pagamento for confirmado o acesso é liberado automaticamente.", "text-amber-500"],
    failed: [XCircle, "Pagamento não aprovado", "Tente novamente ou escolha outra forma de pagamento.", "text-red-500"],
    error: [XCircle, "Não foi possível confirmar agora", "Verifique o status em Planos.", "text-red-500"],
  }[state.kind];
  const [Icon, title, text, cls] = view;
  return (
    <div className="card-surface mx-auto max-w-md p-8 text-center space-y-4" data-testid="payment-return">
      <Icon className={`mx-auto h-12 w-12 ${cls}`} />
      <h1 className="font-display text-2xl font-bold" data-testid="payment-return-title">{title}</h1>
      <p className="text-sm text-muted-foreground">{text}</p>
      <Button asChild data-testid="payment-return-btn"><Link to={state.kind === "paid" ? "/app" : "/app/planos"}>{state.kind === "paid" ? "Ir para o painel" : "Voltar aos planos"}</Link></Button>
    </div>
  );
}
